import { ref as a, inject as s, computed as n, unref as u } from "vue";
import { useGlobalSize as v } from "./index607.js";
import { useProp as d } from "./index646.js";
import { formContextKey as f, formItemContextKey as c } from "./index574.js";
const y = (i, o = {}) => {
  const e = a(void 0), l = o.prop ? e : d("size"), r = o.global ? e : v(), t = o.form ? { size: void 0 } : s(f, void 0), m = o.formItem ? { size: void 0 } : s(c, void 0);
  return n(
    () => l.value || u(i) || m?.size || t?.size || r.value || ""
  );
}, C = (i) => {
  const o = d("disabled"), e = s(f, void 0);
  return n(() => {
    var l, r, t;
    return (t = (r = (l = o.value) != null ? l : u(i)) != null ? r : e?.disabled) != null ? t : !1;
  });
};
export {
  C as useFormDisabled,
  y as useFormSize
};
